module.exports = __webpack_public_path__ + "static/media/logo.5bf7db72.png";